import svgJar from 'ember-svg-jar/helpers/svg-jar';
import './nais-header-logo.scss';

<template>
  <a
    href="/"
    class="component-nais-header-logo"
    ...attributes
    aria-label="National Association of Independent Schools Market View"
  >
    {{svgJar "nais-logo" alt="National Association of Independent Schools"}}
    {{svgJar "market-view" alt="Market View"}}
  </a>
</template>
